/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck
/* eslint-disable @typescript-eslint/no-explicit-any */
declare function serverErrorMsg(ret: any): any;
import { hall } from '@/hall'
import { ModuleBase } from './ModuleBase'
import { base } from '@/base/base'
import { MsgIDs } from '@/defines/MsgIDs'
import { PopupViews } from '@/defines/EnumDefine'
import { wsClient } from '@/net/WebSocketClient'

export class DailyTaskModule extends ModuleBase {
  public typeBtn = 0
  public rewardNum = 0 //奖励金额

  public dailyTaskInfo_: any = null
  public BetCof: any = null
  public BetStatus: any = null
  public BetGold: any = null
  public DepCof: any = null
  public DepStatus: any = null
  public DepGold: any = null

  public clickIndex = 0 //点击的是哪个按钮，all的话是99

  init(): void {
    this.dailyTaskInfo_ = null
    this.BetCof = null
    this.BetStatus = null
    this.BetGold = null
    this.DepCof = null
    this.DepStatus = null
    this.DepGold = null
  }

  onClear(): void {
    this.dailyTaskInfo_ = null
    this.BetCof = null
    this.BetStatus = null
    this.BetGold = null
    this.DepCof = null
    this.DepStatus = null
    this.DepGold = null
  }

  onLoad(): void {}

  onDestroy(): void {}

  onPreloadData(): void {
    hall.dailyTaskModule.sendDailyTaskConfig()
  }

  inits2c(): void {
    ;(hall.s2c as any)['onClientEveryDayAck'] = function (msg: any) {
      //           uint32 ret = 1;
      // uint32 UserID = 2;			// 玩家ID
      // uint32 ChannelID = 3;       // 渠道ID

      // string BetCof = 4;          // 下注流水配置
      // string BetStatus = 5;       // 下注流水道具领取情况
      // string BetGold = 6;         // 当天下注流水

      // string DepCof = 7;          // 充值流水配置
      // string DepStatus = 8;       // 充值流水道具领取情况
      // string DepGold = 9;         // 当天累计充值

      if (msg == null || msg.ret != 0 || msg.UserID != hall.userModule.userId) {
        base.toast(serverErrorMsg(msg.ret))
        return
      }
      hall.dailyTaskModule.dailyTaskInfo_ = msg
      hall.dailyTaskModule.changeInfoJson()
      hall.eventDispatcher.emit(hall.EventDefine.OnDailyTaskInfo)
      hall.eventDispatcher.emit(hall.EventDefine.ChangeBindActivityRed) //刷新日常任务红点
    }

    ;(hall.s2c as any)['onClientEveryDayGoldAck'] = function (msg: any) {
      //          uint32 ret = 1;
      // uint32 UserID = 2;			// 玩家ID
      // uint32 ChannelID = 3;       // 渠道ID
      // string EDatGold = 4; // 金币

      if (msg == null || msg.ret != 0 || msg.UserID != hall.userModule.userId) {
        base.toast(serverErrorMsg(msg.ret))
        return
      }
      hall.eventDispatcher.emit(hall.EventDefine.OnDailyTaskGoldBtn)
      hall.dailyTaskModule.rewardNum = Number(msg.EDatGold)
      hall.eventDispatcher.emit(hall.EventDefine.OnDailyTaskGoldChange)
      hall.userModule.sendClient2ProxyReqGetBalance()
      hall.eventDispatcher.emit(hall.EventDefine.ChangeBindActivityRed) //刷新日常任务红点
    }
  }

  //前端请求每日任务数据
  sendDailyTaskConfig(): void {
    const msg = {
      UserID: hall.userModule.userId,
      ChannelID: base.channelId,
    }

    wsClient.send(MsgIDs.ClientEveryDayReq, msg)
  }

  //前端请求领取每日任务奖励
  sendEveryDayGold(allId: any): void {
    // uint32 UserID = 1;	// 玩家ID
    // uint32 ChannelID = 2;
    // uint32 IdType = 3;  // 0:Betting,1:Deposit
    // repeated string AllID = 4;

    const msg = {
      UserID: hall.userModule.userId,
      ChannelID: base.channelId,
      IdType: this.typeBtn,
      AllID: allId,
    }

    wsClient.send(MsgIDs.ClientEveryDayGoldReq, msg)
  }

  changeInfoJson() {
    if (this.dailyTaskInfo_ == null) {
      return
    }
    this.BetCof = this.dailyTaskInfo_.BetCof.split(',').map((item) => {
      const [value, count] = item.split(':').map(Number)
      return { value, count }
    })
    this.BetStatus = this.dailyTaskInfo_.BetStatus.split(',').map((item) => {
      const [value, isClick] = item.split(':').map(Number)
      return { value, isClick }
    })
    this.BetGold = Number(this.dailyTaskInfo_.BetGold)
    this.DepCof = this.dailyTaskInfo_.DepCof.split(',').map((item) => {
      const [value, count] = item.split(':').map(Number)
      return { value, count }
    })
    this.DepStatus = this.dailyTaskInfo_.DepStatus.split(',').map((item) => {
      const [value, isClick] = item.split(':').map(Number)
      return { value, isClick }
    })
    this.DepGold = Number(this.dailyTaskInfo_.DepGold)
  }

  isBettingHaveReward() {
    if (this.BetCof == null) {
      return false
    }
    for (let i = 0; i < this.BetCof.length; i++) {
      if (this.BetStatus[i].isClick == 0) {
        //还没有领取
        const isRew = this.BetGold >= this.BetCof[i].value
        if (isRew) {
          //可以领取
          return true
        }
      }
    }
    return false
  }

  isDepositHaveReward() {
    if (this.DepCof == null) {
      return false
    }
    for (let i = 0; i < this.DepCof.length; i++) {
      if (this.DepStatus[i].isClick == 0) {
        //还没有领取
        const isRew = this.DepGold >= this.DepCof[i].value
        if (isRew) {
          //可以领取
          return true
        }
      }
    }
    return false
  }

  isShowDailyRed() {
    const BettingHave = this.isBettingHaveReward()
    const DepositHave = this.isDepositHaveReward()
    if (BettingHave || DepositHave) {
      return true
    }
    return false
  }

  //获取ClaimAll可以领取的奖励
  getClaimAllBetting() {
    const claimArr = []
    for (let i = 0; i < this.BetCof.length; i++) {
      if (this.BetStatus[i].isClick == 0) {
        //还没有领取
        const isRew = this.BetGold >= this.BetCof[i].value
        if (isRew) {
          //可以领取
          const str = this.BetCof[i].value + ''
          claimArr.push(str)
        }
      }
    }
    return claimArr
  }

  //获取DepositAll可以领取的奖励
  getDepositAllBetting() {
    const claimArr = []
    for (let i = 0; i < this.DepCof.length; i++) {
      if (this.DepStatus[i].isClick == 0) {
        //还没有领取
        const isRew = this.DepGold >= this.DepCof[i].value
        if (isRew) {
          //可以领取
          const str = this.DepCof[i].value + ''
          claimArr.push(str)
        }
      }
    }
    return claimArr
  }

  // 是否需要弹窗
  popupView() {
    // 增加主动弹出逻辑，每天弹出一次，在其它弹框权重后面
    if (this.BetCof == null) {
      return false
    }
    const BettingHave = this.isBettingHaveReward()
    const DepositHave = this.isDepositHaveReward()
    if (BettingHave || DepositHave) {
      hall.popupViewModule.addPopupView(PopupViews.DailyTaskPanel)
    }
  }
}
